import { Text } from '@h2/components/typography/text'
import { Page } from '@h2/common/components/page'
import { Heading } from '@h2/components/typography/heading'

const PrivacyPolicy = () => {
  return (
    <Page>
      <Page.Title>2024 Privacy Statement</Page.Title>
      <Page.Layout>
        <Page.Content>
          <Heading level={2}>I. Introduction</Heading>
          <Text>
            This Supplement to{' '}
            <a
              href="https://www.powerschool.com/privacy/"
              target="_blank"
              rel="noreferrer">
              Global Privacy Statement
            </a>{' '}
            for PowerSchool Publicly Accessible Product Headed2 (
            <strong>&quot;Headed2 Privacy Supplement&quot;</strong>) provides information
            to you on how PowerSchool Group LLC and its various operating subsidiaries
            (&quot;PowerSchool&quot;) protects the personal information we may collect
            from you when you access our publicly accessible products. This Headed2
            Privacy Supplement describes how PowerSchool Group LLC collects and uses your
            personal information which is a part of the Collected Data processed by our
            publicly accessible products. We also describe how you may exercise your
            personal data rights available under applicable laws.
          </Text>
          <Text>
            This Headed2 Privacy Supplement incorporates by reference, sections I, V-XIV
            of PowerSchool Global Privacy Statement covering our products and solutions
            licensed to school, districts and other educational institutions,
            applicability to various International Privacy laws. References to{' '}
            <strong>&quot;us&quot;, &quot;we&quot;, &quot;our&quot;</strong> or{' '}
            <strong>&quot;PowerSchool&quot;</strong> in this Headed2 Privacy Supplement,
            are referring to PowerSchool.
          </Text>

          <Heading level={2}>II. PUBLICLY ACCESSIBLE PRODUCTS</Heading>
          <Text>
            PowerSchool makes certain solutions directly available to the public. For
            these products, an individual voluntarily accepts the license terms to access
            the solution and expressly consents to PowerSchool’s collection of certain
            personal information. For these publicly accessible products only, PowerSchool
            acts as the data collector and data processor of this Collected Data.
          </Text>
          <Heading level={3} variant="font">
            Headed2
          </Heading>
          <Text>
            This application allows offers services related to career literacy for
            individuals via self-assessment activities, data on industry sectors, and
            local opportunities network. The product also provides the ability to connect
            with Navigators – who help individuals facilitate in better understanding of a
            specific career path and guide their journey. The product collects Personal
            Information like name, age, email address, zip code, profession, current job
            details, academic details – degrees obtained, ranks, grades, income,
            investments. The personal data of the individual is processed to provide them
            with useful insight, guide the users towards discovery of how they relate to
            careers, and support exploration and planning process. To ensure the safety of
            the collected personal data, PowerSchool collects only required minimal data,
            no excess data is collected or stored in the product. PowerSchool deploys
            several security measures to ensure the integrity and confidentiality of
            processed personal data. The product supports the individual rights in the
            manner by providing the User Right to access i.e. view and export their own
            data and the Right to be forgotten i.e. the user can request that their data
            and the account be deleted. To exercise your privacy rights under state,
            federal, provincial or country privacy legislation related to this application
            and the Personal Information it collects and processes submit your request to{' '}
            <a
              href="https://forms.office.com/r/C0PV71rD5S"
              target="_blank"
              rel="noreferrer">
              Data Subject Access Request
            </a>
            .
          </Text>

          <Heading level={2}>III. OTHER PROVISIONS</Heading>
          <Heading level={3} variant="font">
            A. DATA RETENTION
          </Heading>
          <Text>
            PowerSchool retains Collected Data only for the length of time needed to
            provide services to you. You may submit a request for us to delete your
            Personal Information from the product. You acknowledge this means once we
            process this request, you may not be able to use any of the services of the
            product.
          </Text>
          <Heading level={3} variant="font">
            B. USER CONSENT
          </Heading>
          <Text>
            By clicking on &quot;I ACCEPT&quot; button in response to the Terms of Use
            (&quot;ToU&quot;) presented to you in the Headed2, you consent to our use of
            your personal information, Collected Data, in accordance with the ToU of
            Headed2 and the Global Privacy Statement including this Supplement.
          </Text>
          <Heading level={3} variant="font">
            C. NOTIFICATION REGARDING PRIVACY POLICY UPDATES
          </Heading>
          <Text>
            From time to time, we may update this Headed2 Privacy Supplement and the
            Global PrIvacy Statement. We will notify you about material changes by placing
            a notice on our Sites. We encourage you to periodically review these
            documents.
          </Text>
          <Heading level={3} variant="font">
            D. DISCLOSURE OF COLLECTED DATA
          </Heading>
          <Text>
            We may share and disclose Information in the following ways or for any other
            purpose disclosed at the time of collection:
          </Text>
          <Text>
            1. Legal and law enforcement purposes. We may disclose Collected Data in
            response to legal process, for example in response to a court order or a
            subpoena, or in response to a law enforcement agency&apos;s request. We also
            may disclose such Collection Data to third parties: (i) in connection with
            fraud prevention activities, (ii) where we believe it is necessary to
            investigate, prevent, or take action regarding illegal activities, (iii) in
            situations that may involve violations of our terms of use or other rules,
            (iv) to protect our rights.
          </Text>
          <Text>
            2. Change of control. We may transfer Collected Data in the event of a
            business transaction, such as if we or one of our business units or our
            relevant assets are acquired by, sold to, or merged with another company or as
            part of a bankruptcy proceeding or a business reorganization. Such transfer
            would not without more change the scope of your consent given to PowerSchool
            as data controller of the Collected Data.
          </Text>
          <Text>
            3. Additional consent. We may otherwise disclose Collected Data when you
            provide PowerSchool with additional consent to do so.
          </Text>
        </Page.Content>
      </Page.Layout>
      <Page.Bottom />
    </Page>
  )
}

export { PrivacyPolicy }
